import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectMemberList = createSelector(
	(state: IStore) => state.memberList,
	(memberList) => memberList
)
